var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQkrHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 56.057 37.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(-6.999 -15.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7615",
    "data-name": "Group 7615",
    transform: "translate(6.999 15.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARC_424_",
    transform: "translate(0 25.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7596",
    "data-name": "Group 7596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22733",
    "data-name": "Path 22733",
    d: "M15.056,42.894a1.14,1.14,0,0,1-.161-.011,22.244,22.244,0,0,1-7.3-2.39,1.122,1.122,0,1,1,1.056-1.98,19.934,19.934,0,0,0,6.565,2.149,1.122,1.122,0,0,1-.158,2.232Z",
    transform: "translate(-6.999 -38.381)",
    fill: "#96006b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7617",
    "data-name": "Group 7617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARC_423_",
    transform: "translate(46.879 25.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7597",
    "data-name": "Group 7597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22734",
    "data-name": "Path 22734",
    d: "M49.935,42.893a1.121,1.121,0,0,1-.158-2.231,19.926,19.926,0,0,0,6.565-2.149,1.122,1.122,0,0,1,1.056,1.98,22.244,22.244,0,0,1-7.3,2.39A1.328,1.328,0,0,1,49.935,42.893Z",
    transform: "translate(-48.815 -38.382)",
    fill: "#f48116"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_422_",
    transform: "translate(35.152 14.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7598",
    "data-name": "Group 7598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22735",
    "data-name": "Path 22735",
    d: "M39.475,34.037a1.121,1.121,0,0,1-.938-1.733,8.545,8.545,0,0,1,7.181-3.891,1.121,1.121,0,0,1,0,2.242,6.3,6.3,0,0,0-5.3,2.873A1.118,1.118,0,0,1,39.475,34.037Z",
    transform: "translate(-38.354 -28.412)",
    fill: "#f48116"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_38_",
    transform: "translate(37.67 2.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7599",
    "data-name": "Group 7599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22736",
    "data-name": "Path 22736",
    d: "M47.931,32a7.33,7.33,0,1,1,7.33-7.33A7.428,7.428,0,0,1,47.931,32Zm0-12.418a5.088,5.088,0,1,0,5.088,5.088A5.157,5.157,0,0,0,47.931,19.578Z",
    transform: "translate(-40.6 -17.336)",
    fill: "#f48116"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_421_",
    transform: "translate(46.363 14.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7600",
    "data-name": "Group 7600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22737",
    "data-name": "Path 22737",
    d: "M56.926,38.106A1.12,1.12,0,0,1,55.8,36.985a6.337,6.337,0,0,0-6.33-6.33,1.121,1.121,0,1,1,0-2.242,8.583,8.583,0,0,1,8.572,8.572A1.121,1.121,0,0,1,56.926,38.106Z",
    transform: "translate(-48.354 -28.413)",
    fill: "#f48116"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_818_",
    transform: "translate(41.395 14.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7601",
    "data-name": "Group 7601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22738",
    "data-name": "Path 22738",
    d: "M50.012,30.654H45.044a1.121,1.121,0,1,1,0-2.242h4.968a1.121,1.121,0,0,1,0,2.242Z",
    transform: "translate(-43.923 -28.412)",
    fill: "#f48116"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_817_",
    transform: "translate(53.814 21.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7602",
    "data-name": "Group 7602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22739",
    "data-name": "Path 22739",
    d: "M56.121,41.027A1.12,1.12,0,0,1,55,39.906V36.18a1.121,1.121,0,1,1,2.242,0v3.725a1.12,1.12,0,0,1-1.121,1.121Z",
    transform: "translate(-55 -35.059)",
    fill: "#f48116"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_816_",
    transform: "translate(23.596 16.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7604",
    "data-name": "Group 7604",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22741",
    "data-name": "Path 22741",
    d: "M35.791,32.5H29.167a1.121,1.121,0,0,1,0-2.242h6.624a1.121,1.121,0,1,1,0,2.242Z",
    transform: "translate(-28.046 -30.259)",
    fill: "#ff0185"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_419_",
    transform: "translate(12.421 14.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7605",
    "data-name": "Group 7605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22742",
    "data-name": "Path 22742",
    d: "M25.442,34.037a1.121,1.121,0,0,1-.941-.509,6.309,6.309,0,0,0-5.3-2.873,1.121,1.121,0,1,1,0-2.242A8.544,8.544,0,0,1,26.38,32.3a1.121,1.121,0,0,1-.938,1.733Z",
    transform: "translate(-18.078 -28.412)",
    fill: "#96006b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7616",
    "data-name": "Group 7616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARC_420_",
    transform: "translate(13.66 16.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7603",
    "data-name": "Group 7603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22740",
    "data-name": "Path 22740",
    d: "M20.306,42.436a1.12,1.12,0,0,1-1.121-1.121A11.068,11.068,0,0,1,30.24,30.259a1.121,1.121,0,0,1,0,2.242,8.823,8.823,0,0,0-8.813,8.813A1.121,1.121,0,0,1,20.306,42.436Z",
    transform: "translate(-19.185 -30.259)",
    fill: "#ff0185"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_815_",
    transform: "translate(13.66 26.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7606",
    "data-name": "Group 7606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22743",
    "data-name": "Path 22743",
    d: "M20.306,46.33a1.12,1.12,0,0,1-1.121-1.121V40.241a1.121,1.121,0,1,1,2.242,0v4.968A1.121,1.121,0,0,1,20.306,46.33Z",
    transform: "translate(-19.185 -39.12)",
    fill: "#ff0185"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_37_",
    transform: "translate(18.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7607",
    "data-name": "Group 7607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22744",
    "data-name": "Path 22744",
    d: "M33.016,34.29a9.527,9.527,0,0,1-9.4-9.4,9.4,9.4,0,0,1,18.8,0A9.527,9.527,0,0,1,33.016,34.29Zm0-16.559a7.158,7.158,0,1,0,7.158,7.158A7.254,7.254,0,0,0,33.016,17.731Z",
    transform: "translate(-23.615 -15.489)",
    fill: "#ff0185"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_418_",
    transform: "translate(30.219 16.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7608",
    "data-name": "Group 7608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22745",
    "data-name": "Path 22745",
    d: "M45.009,42.436a1.12,1.12,0,0,1-1.121-1.121A8.823,8.823,0,0,0,35.075,32.5a1.121,1.121,0,1,1,0-2.242A11.068,11.068,0,0,1,46.131,41.314,1.12,1.12,0,0,1,45.009,42.436Z",
    transform: "translate(-33.954 -30.259)",
    fill: "#ff0185"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_814_",
    transform: "translate(40.152 26.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7609",
    "data-name": "Group 7609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22746",
    "data-name": "Path 22746",
    d: "M43.936,46.33a1.12,1.12,0,0,1-1.121-1.121V40.241a1.121,1.121,0,1,1,2.242,0v4.968A1.12,1.12,0,0,1,43.936,46.33Z",
    transform: "translate(-42.815 -39.12)",
    fill: "#ff0185"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_417_",
    transform: "translate(13.66 31.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7610",
    "data-name": "Group 7610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22747",
    "data-name": "Path 22747",
    d: "M33.552,49.112a29.254,29.254,0,0,1-13.774-3.45,1.122,1.122,0,1,1,1.056-1.98,26.98,26.98,0,0,0,25.437,0,1.122,1.122,0,0,1,1.056,1.98,29.275,29.275,0,0,1-13.775,3.45Z",
    transform: "translate(-19.184 -43.551)",
    fill: "#ff0185"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_36_",
    transform: "translate(3.726 2.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7611",
    "data-name": "Group 7611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22748",
    "data-name": "Path 22748",
    d: "M17.653,32a7.33,7.33,0,0,1,0-14.66,7.33,7.33,0,0,1,0,14.66Zm0-12.418a5.088,5.088,0,1,0,5.088,5.088A5.156,5.156,0,0,0,17.653,19.578Z",
    transform: "translate(-10.323 -17.336)",
    fill: "#96006b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_416_",
    transform: "translate(0.001 14.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7612",
    "data-name": "Group 7612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22749",
    "data-name": "Path 22749",
    d: "M8.121,38.106A1.12,1.12,0,0,1,7,36.985a8.583,8.583,0,0,1,8.572-8.572,1.121,1.121,0,1,1,0,2.242,6.336,6.336,0,0,0-6.33,6.33A1.121,1.121,0,0,1,8.121,38.106Z",
    transform: "translate(-7 -28.413)",
    fill: "#96006b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_813_",
    transform: "translate(7.452 14.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7613",
    "data-name": "Group 7613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22750",
    "data-name": "Path 22750",
    d: "M19.735,30.654H14.767a1.121,1.121,0,0,1,0-2.242h4.968a1.121,1.121,0,0,1,0,2.242Z",
    transform: "translate(-13.646 -28.412)",
    fill: "#96006b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_812_",
    transform: "translate(0.001 21.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7614",
    "data-name": "Group 7614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22751",
    "data-name": "Path 22751",
    d: "M8.121,41.027A1.12,1.12,0,0,1,7,39.906V36.18a1.121,1.121,0,1,1,2.242,0v3.725a1.12,1.12,0,0,1-1.121,1.121Z",
    transform: "translate(-7 -35.059)",
    fill: "#96006b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQkrHr);
export default __webpack_public_path__ + "static/media/QkrHR.57d2762a2c049ac72635fb503dc1d0ae.svg";
export { ForwardRef as ReactComponent };